/** URL + API query params for GET /api/contacts (list page only; not Redux). */
import {
  appendPaginationParams,
  defaultPaginationQuery,
  parsePaginationQuery,
  SearchablePaginationQueryParams
} from '../../common/utils/pagination';

export interface ContactsListQueryParams extends SearchablePaginationQueryParams {
  showInactive: boolean;
}

export const defaultContactsListQuery: ContactsListQueryParams = {
  search: '',
  showInactive: false,
  ...defaultPaginationQuery
};

export function parseContactsListQuery(search: string): ContactsListQueryParams {
  const q = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(q);
  const searchText = params.get('search') ?? '';
  const showInactive = params.get('showInactive') === 'true';
  const { page, pageSize } = parsePaginationQuery(params, defaultPaginationQuery);
  return { search: searchText, showInactive, page, pageSize };
}

/** Builds query string; omits params that match defaults for shorter URLs. */
export function buildContactsListSearch(query: ContactsListQueryParams): string {
  const p = new URLSearchParams();
  if (query.search) p.set('search', query.search);
  if (query.showInactive) p.set('showInactive', 'true');
  appendPaginationParams(p, { page: query.page, pageSize: query.pageSize }, defaultPaginationQuery);
  const s = p.toString();
  return s ? `?${s}` : '';
}
